import i18next from 'i18next'

const formatDateByLocale = (date, format = {}) => {
  const defaultFormat = {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit'
  }
  const dateValue = !isNaN(date) && typeof date === 'string' ? +date : date
  return date
    ? i18next.t('intlDateTime', {
        val: new Date(dateValue),
        formatParams: {
          val: {
            ...defaultFormat,
            ...format
          }
        }
      })
    : dateValue
}

export default formatDateByLocale
